
/**
 *自动创建个人库组件
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Checkbox, Modal,Input,Empty} from 'antd';
import BaseComponent from "../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import {message} from './Mess'
const { Search } = Input;


export default class PersonalLibrary  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            visible:false,
            dataSource:{},
            searchText:'',
            peopleList:[],
        }
    }

    componentWillMount() {
    }
    componentDidMount() {

    }

    render() {
        return(
            <div >
               <Button icon={"folder"}  type='primary' onClick={() => {this.CreatePersonal()
               }}>自动创建个人库</Button>
                <Modal
                    maskClosable={false}
                    keyboard={true}
                    title="自动创建个人库"
                    visible={this.state.visible}
                    centered
                    destroyOnClose={true}
                    width={350}
                    onOk={()=>{
                        this.saveData()
                    }}
                    okText={'批量创建'}
                    onCancel={()=>{this.setState({visible:false})}}>
                    <div>
                        <Search
                            allowClear={true}
                            placeholder="请输入关键字"

                            value={this.state.searchText}
                            onSearch={(value) => {
                                this.setState({searchText:value},()=>{
                                    this.getList()
                                })
                            }}
                            onChange={(e) => {

                                this.state.searchText = e.target.value;
                                this.setState({})
                            }}
                            style={{width: 300}}
                        />
                        <div style={{height:300,marginTop:'10px'}}>
                            {this.state.peopleList&&this.state.peopleList.length?<Scrollbars > {this.state.peopleList&&this.state.peopleList.length>0&&this.state.peopleList.map((item,index)=>{
                                return(
                                    <div style={{lineHeight:'40px',marginLeft:20}} key={item.id}><Checkbox disabled={item.disable}  checked={item.checked} onChange={(e)=>{
                                        item.checked = e.target.checked;
                                        this.setState({})
                                    }}>{item.name}</Checkbox></div>
                                )
                            })}
                            </Scrollbars>:<Empty style={{paddingTop: '60px'}}/>}
                        </div>



                    </div>

                </Modal>
            </div>
        )
    }

    //批量创建的接口
    saveData(){
        let array= [];
        this.state.peopleList&&this.state.peopleList.length&&this.state.peopleList.forEach((item,index)=>{
            if(!item.IsChecked){
                array.push(item)
            }
        });
        //筛选出没有选过的用户
        if(array&&array.length){
            let num=0;
            array.forEach((item,index)=>{
                if(item.checked){

                    num++;
                    this.request({
                        url: '/cm-sites-storage-management/zykManagement/createPersonRootDir',
                        method: "post",
                        body: {
                            userId:item.id,
                            name:item.name,
                            fid:this.props.currrent
                        },
                        contentType: "json",
                        callBack: (data) => {
                            if(data){
                                message.success('操作成功');
                                this.setState({visible:false});
                                this.props.callBack&&this.props.callBack()
                            }
                        }
                    });
                }
            })
            if(num===0){
                message.error('请选择要创建的个人库！')
            }
        }else{
            message.error('没有新的用户可创建！')

        }

    }
   //点击创建自动创建个人库
    CreatePersonal(){
        this.setState({searchText:''},()=>{
            this.getList()
        })

    }
    //创建个人库弹框里面的获取个人列表
    getList(){

        this.request({
            url: '/cm-sites-storage-management/zykManagement/getPersonRootDirList',
            method: "get",
            body: {virtualFileId:this.props.currrent,searchName:this.state.searchText},
            contentType: "json",
            callBack: (data) => {
                if (data) {
                    this.public(data)
                }
            }
        });
    }
   //回显选中的人以及禁止的状态
    public(data){
        data&&data.userArray&&data.userArray.length>0&&data.userArray.forEach((item,index)=>{
            if( data&&data.userIdList&&data.userIdList.length){
                data.userIdList.forEach((i,ids)=>{
                    if(item.id === i){
                        item.checked = true;
                        item.disable = true;
                        item.IsChecked = true
                    }
                })
            }

        });
        this.setState({peopleList:data.userArray,dataSource:data,visible:true,},()=>{
        })
    }

}
